module.exports = __webpack_public_path__ + "img/Discord-Logo-Color.f8389ca1.svg";